var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPaidAmount(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 20,
    viewBox: "0 0 24 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.1362 2.10611C23.1085 1.50237 22.8354 0.957 22.4257 0.555271C22.016 0.153541 21.4697 -0.0484727 20.8957 0.00990217C20.3217 0.0390781 19.8032 0.326367 19.4479 0.757284L8.52291 13.6848L3.52661 8.91454C3.11693 8.51281 2.57067 8.31079 1.99667 8.33998C1.42267 8.36916 0.904169 8.62726 0.548887 9.05818C0.166947 9.48909 -0.0251146 10.0636 0.00263496 10.6674C0.0303736 11.2711 0.275761 11.8165 0.68545 12.1902L7.26833 18.481C7.65027 18.8547 8.16986 19.0556 8.68837 19.0556H8.82493C9.37118 19.0264 9.88968 18.7683 10.2994 18.3082L22.6444 3.68631C22.973 3.25539 23.164 2.68067 23.1362 2.10611Z",
    fill: "#006E7E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPaidAmount);
export default __webpack_public_path__ + "static/media/paid_Amount.9a15a932661e0a8b7de69635b1c6ba10.svg";
export { ForwardRef as ReactComponent };